$(document).ready(function(){

// New Header Js [Globle]
$('.mobile-menu').click(function (event) {
    event.preventDefault();
    if ($(window).width() < 769) {
        $('.header-content .main-menu').addClass('open');
        $('body').addClass('overflow-hidden');
    }
});
$('.header-content .main-menu .close-btn').click(function (event) {
    event.preventDefault();
    if ($(window).width() < 769) {
        $('.header-content .main-menu').removeClass('open');
        $('body').removeClass('overflow-hidden');
    }
});

var numToShow = $(".health-professionals-section").attr("data-pagination") - 1;
var TotalItem = parseInt($(".load-more-button").attr("data-totalItem"));

$(".professionals-trust-wrapper .professional-trust").each(function(i,e) {
    if (i <= numToShow) {
        $(this).addClass('active');
    }
});

$(".load-more-button .btn").click(function(){
  var showSlide = $(".professionals-trust-wrapper .professional-trust.active").length + numToShow;
  $(".professionals-trust-wrapper .professional-trust").each(function(i,e) {
    if (i <= showSlide) {
        $(this).show();
        $(this).addClass('active');
        if (showSlide >= TotalItem) {
            $(".load-more-button").hide();
        }
    }
  });
});
  
// protein-lovers-carousel [PDP Page]
    $('.protein-lovers-carousel').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev slick-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 10.5L11 20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 10.5L11 20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 851,
            settings: {
                slidesToShow: 2,
                arrows: false,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                arrows: false,
            }
        }
        ]
    });

    // blog-carousel [PDP Page]
    $('.blog_carousel').slick({
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev slick-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 10.5L11 20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 10.5L11 20" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 851,
            settings: {
                slidesToShow: 2,
                arrows: false,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                arrows: false,
            }
        }
        ]
    });

    // Nutritionists Carousel [PDP Page]
    $('.nutritionists_profile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
        autoplay: true,
        autoplaySpeed:10000,
        speed:1000,
		fade: true,
		asNavFor: '.nutritionists-feedback',
	});
	$('.nutritionists-feedback').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:10000,
        speed:1000,
		asNavFor: '.nutritionists_profile',
		dots: false,
		focusOnSelect: true,
		arrows: false,
		dots: true,
	});

    // Whey Protein Video [PDP Page]
    $('.video-inner').on('click', function() {
      var video = $(this).find('video')[0];
      var playPauseBtn = $(this).find('.play-pause-btn');
      if (video.paused) {
        video.play();
        $(playPauseBtn).children('img').hide(); 
      } else {
        video.pause();
        $(playPauseBtn).children('img').show();
      }
    });

    // New FAQs [PDP Page]
    $('.new-faqs-section .faqs-wrapper .faqs-acco-title h3').click(function () {
		$('.new-faqs-section .faqs-wrapper .faqs-acco-title h3').removeClass('active');
		$('.new-faqs-section .faqs-wrapper .faqs-acco-content').slideUp();
		if (!$(this).parent('.faqs-acco-title').next().is(':visible')) {
			$(this).parent('.faqs-acco-title').next().slideDown();
			$(this).addClass('active');
		}
	});
    $('.new-faqs-section .faqs-wrapper .faqs-acco-title p').click(function () {
		$('.new-faqs-section .faqs-wrapper .faqs-acco-title p').removeClass('active');
		$('.new-faqs-section .faqs-wrapper .faqs-acco-content').slideUp();
		if (!$(this).parent('.faqs-acco-title').next().is(':visible')) {
			$(this).parent('.faqs-acco-title').next().slideDown();
			$(this).addClass('active');
		}
	});

    //faq popup start
    var $openPopupLink = $(".ask_que_btn");
    var $productPopup = $(".get-in-touch-modal");
    var $close_ic = $(".faq_close_click");
    var $pop_over = $(".pop-ovelay");
    
    // Add click event listener to the open-popup link
    $openPopupLink.click(function() {
        $productPopup.addClass("active");
    });

    // Add click event listener to the close icon
    $close_ic.click(function() {
        $productPopup.removeClass("active");
    });

    // Add click event listener to the pop-over overlay
    $pop_over.click(function() {
        $productPopup.removeClass("active");
    });
    //faq popup end
  
    // Select the h1 element within the .hero-title class
      var heroTitleH1 = $('.hero-title h1');
      
    // Check if the h1 element has the style text-transform: uppercase;
    if (heroTitleH1.css('text-transform') === 'uppercase') {
        // Add the class version2 to the h1 element
        heroTitleH1.addClass('version2');
    }

  
    // Clean Label Modal pop-up start
    var $openPopupLink2 = $(".nutri_pop_up");
    var $productPopup2 = $(".clean_label_modal");
    var $close_ic2 = $(".nutri_close");
    var $pop_over2 = $(".pop-ovelay");
    
    // Add click event listener to the open-popup link
    $openPopupLink2.click(function() {
        $productPopup2.addClass("active");
    });

    // Add click event listener to the close icon
    $close_ic2.click(function() {
        $productPopup2.removeClass("active");
    });

    // Add click event listener to the pop-over overlay
    $pop_over2.click(function() {
        $productPopup2.removeClass("active");
    });
    // Clean Label Modal pop-up end

  
    // Clean Label Modal
    $('.clean_label_table_wrapper .tab-container ul li a').click(function (e) {
        e.preventDefault();

        $('.clean_label_table_wrapper .tab-container ul li a').removeClass('active');
        $(this).addClass('active');

        var tagid = $(this).attr('data-id');
        console.log(tagid);
        
        $('.clean_label_table_wrapper .tab-contents .tab-content').removeClass('current');
        $('.clean_label_table_wrapper .tab-content#'+tagid).addClass('current');
    });

    // Add Class
    function initAccordion() {
      
      setInterval(function () {
          $('.answer_base_app .questions-list .item .cell .ab-link').parent('div').addClass('acco_title'); 
          $('.answer_base_app .questions-list .item .cell .files-list').next('div').addClass('social_following'); 
        
          $('.answer_base_app .questions-list .item .cell .acco_title a').off('click').on('click', function (e) {
              e.preventDefault();
              $('.answer_base_app .questions-list .item .cell .acco_title a').removeClass('active');
              $('.answer_base_app .questions-list .item .cell .answers-list').slideUp();
  
              if (!$(this).parent(".acco_title").siblings(".answers-list").is(':visible')) {
                  $(this).parent(".acco_title").siblings(".answers-list").slideDown();
                  $(this).addClass('active');
              }
          });
      },1000);
      
      setTimeout(function () {
          $('.answer_base_app  .questions-list .grid-x.item:last-of-type').after('<div class="answer_base_app-btns"></div>');
          console.log('work')
          $(".answer_base_app .questions-list a.viewall").appendTo('.answer_base_app-btns').html('Read More');        
          $(".new-faqs-section .cell.auto.ask .ask-details").appendTo('.answer_base_app-btns');
          $(".questions-list .answer_base_app-btns .ask-details a").html('Ask A question');
      },3000);
      
    }
    initAccordion();

  // 15-05 start
  $('#simpAskQuestion').closest('section').addClass('smps_faq');
    $('.view-more').click(function(){
        $('.smps_faq').css('display', 'block');
    });
  // 15-05 end


  // 17-05-2024 SMPS App Accordian Js
    $('.simpAsk-container .accordionSimpQA ul li p.simpQuestionHolder').off('click').on('click', function (e) {
        e.preventDefault();
        $('.simpAsk-container .accordionSimpQA ul li p.simpQuestionHolder').removeClass('active');
        $('.simpAsk-container .accordionSimpQA ul li p:not(:first-child)').slideUp();

        if (!$(this).nextAll('p').is(':visible')) {
            $(this).nextAll('p').slideDown();
            $(this).addClass('active');
        }
    });

  // 23-05-2024
        $('.logo_with_title_section .title').each(function() {
        var words = $(this).text().split(' ');
        if (words.length === 2) {
          $(this).html(words[0] + '<br>' + words[1]);
        } else if (words.length === 3) {
          $(this).html(words[0] + ' ' + words[1] + '<br>' + words[2]);
        }
      });

  // Nav Dropdown js [Globle Js]
      function headerspacing() {
          // Check if site-nav__thumb-menu has class mob-menu-bottom
          if ($('.site-nav__thumb-menu').hasClass('mob-menu-top')) {
              if ($(window).width() < 769) {
                  var header_Height = $('.site-nav__thumb-menu.mobile_site-nav').outerHeight();
                  
                  $('main#MainContent').css("padding-top", header_Height);
                  $('.slide-nav__overflow.slide-nav__overflow--thumb.mob-menu-top').css("top", header_Height);
                
                  if ($("#mob_menu_top").is(":hidden")) {
                    $("main#MainContent").css("padding-top", "");
                    $(".slide-nav__overflow.slide-nav__overflow--thumb").removeClass( "mob-nav-top" );
                    $('.slide-nav__overflow.slide-nav__overflow--thumb.mob-nav-top').css("top", header_Height);
                  } else {
                    $('main#MainContent').css("padding-top", header_Height);
                    $(".slide-nav__overflow.slide-nav__overflow--thumb").addClass( "mob-nav-top" );
                    $('.slide-nav__overflow.slide-nav__overflow--thumb.mob-nav-top').css("top", header_Height);
                  }
      
                
                  
              } else {
                  $('.slide-nav__overflow.slide-nav__overflow--thumb.mob-menu-top').css("top", '');
                  $('main#MainContent').css("padding-top", '');
              }
              
          }
      }
      
      headerspacing();
      $(window).on('resize load orientationchange', function () {
          headerspacing();
      });

  // 
    $(document).ready(function() {
        var $mobMenuBottom = $('#mob_menu_bottom');
        
        if ($mobMenuBottom.css('display') === 'none') {
            console.log('hello world');
        }
    });

  
});


// hide home and login
$(document).ready(function() {
  // Function to hide parent li of a tags with specified text
  function hideParentLiIfText(selector, text) {
    $(selector).each(function() {
      if ($(this).find('a').text().trim() === text) {
        $(this).css('display', 'none');
      }
    });
  }

  // Function to execute the script based on window width
  function executeScript() {
    if ($(window).width() <= 767) {
      // Check if slide-nav__overflow has class mob-nav-top
      if ($('.slide-nav__overflow').hasClass('mob-nav-top')) {
        // Hide parent li of a tag with text "Home"
        hideParentLiIfText('.slide-nav__overflow li', 'Home');
        // Hide parent li of a tag with text "Log in"
        hideParentLiIfText('.slide-nav__overflow li', 'Log in');
      }
    } else {
      // Optionally, you can show the li elements again if the window width is greater than 767
      $('.slide-nav__overflow li').each(function() {
        $(this).css('display', '');
      });
    }
  }

  // Run script on document ready
  executeScript();

  // Run script on window resize
  $(window).resize(function() {
    executeScript();
  });

  // Foote Menu Accordians
      $('.org_menu_drw_title span').click(function () {
          if ($(window).width() < 769) {
              $('.org_menu_drw_title span').removeClass('active');
              $('.org_menu_drw_content').slideUp();
              if (!$(this).parent().next().is(':visible')) {
                  $(this).parent().next().slideDown();
                  $(this).addClass('active');
              }
          }
      });

  // Nutritionists Saying Carousel [Why Protein Page]
  $('body:not(.custom_WhyOurWhey, .template-index) .nutritionists-saying-carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 7,
		slidesToScroll: 1,
		centerMode: false,
        // centerPadding: '141px',
        autoplay: false,
        autoplaySpeed: 2000,
		responsive: [
		{
			breakpoint: 1441,
			settings: {
				slidesToShow: 5,
			}
		},
		{
			breakpoint: 1201,
			settings: {
				slidesToShow: 4,
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
                // centerPadding: '100px',
			}
		},
		{
			breakpoint: 851,
			settings: {
				slidesToShow: 2,
                // centerPadding: '100px',
			}
		},
		{
			breakpoint: 576,
			settings: {
        		arrows: false,
				slidesToShow: 1.2,
                // centerPadding: '78px',
			}
		}
		]
	});

    $('body').on('click', '.nutritionists-saying-carousel .nutritionists-link', function(e) {
        e.preventDefault();
        $('.nutritionists-saying-video-modal').addClass('show');
        let nutritionists_title = $(this).find(".nutritionists_title").html();

        $(".nutritionists_detail").html(" ");
        if( nutritionists_title !="" && typeof nutritionists_title !="undefined" ){
          $(".nutritionists_detail").html(nutritionists_title);  
        }      
        
        var videoElement = $(this).find('video')[0];
        var videoSrc = $(videoElement).find('source').attr('src');
    
        var modalVideoElement = $('.nutritionists-saying-video-modal .nutritionists-video').find('video')[0];
        var modalSource = $(modalVideoElement).find('source');
    
        if (modalSource.attr('src') !== videoSrc) {
            modalSource.attr('src', videoSrc);
            modalVideoElement.load();
        }
         modalVideoElement.play();
    });

    $('body').on('click','.nutritionists-saying-video-modal .close-btn',function(e){
        e.preventDefault();
        $('.nutritionists-saying-video-modal').removeClass('show');
      
      var modalVideoElement = $('.nutritionists-saying-video-modal .nutritionists-video').find('video')[0];
      modalVideoElement.pause();

    });

   // Whey Protein Video [review Page]
    $('.video-inner-review').on('click', function() {
      var video = $(this).find('video')[0];
      var playPauseBtn = $(this).find('.play-btn');
      var PauseBtn = $(this).find('.pause-btn');
      if (video.paused) {
        video.play();
        $(playPauseBtn).hide(); 
        $(PauseBtn).show(); 
      } else {
        video.pause();
        $(playPauseBtn).show();
        $(PauseBtn).hide();
      }
    });

    // mute video section review start
        var $video = $(".video-inner-review video");
        var $muteBtn = $(".mute_btn");
        var $soundBtn = $(".sound_btn");    
        function updateButtonVisibility() {
          if ($video.prop('muted')) {
            $muteBtn.show(); 
            $soundBtn.hide(); 
          } else {
            $muteBtn.hide(); 
            $soundBtn.show(); 
          }
        }
        function toggleMute() {
          var isMuted = $video.prop('muted');
          $video.prop('muted', !isMuted);
          updateButtonVisibility(); 
        }  
        $video.prop('muted', true);
        updateButtonVisibility();
          $muteBtn.on('click', function() {
            toggleMute(); 
          });
          $soundBtn.on('click', function() {
            toggleMute(); 
          });
    // mute video section review end

    // Padding top add on Main Content Js [Globle]
    function headerspace() {
        var windowWidth = $(window).width();
            
        if (windowWidth < 769) {
            var headerHeight = $('header.site_header').outerHeight();
            $('main#MainContent').css("padding-top", headerHeight);
            
            $(window).scroll(function(){
                if ($(this).scrollTop() > 0) {
                    $('header.site_header').addClass('header-sticky');
                } else {
                    $('header.site_header').removeClass('header-sticky');
                }
            });
        } else {
            $('main#MainContent').css("padding-top", '');
            $(window).scroll(function(){
                $('header.site_header').removeClass('header-sticky');
            });
        }
	}
	headerspace();
	$(window).on('resize load', function () {
        headerspace();
	});

    // Onscroll & Onclick Navigation Menu Active [Why Our Whey Page]
    var ourwheyNavigation = $('.our-whey-navigation');
    var ourwheyNav_height = ourwheyNavigation.outerHeight();
    var headerHeight = $('header.site_header').outerHeight();
    var isScrolling = false;

    $(window).on('resize', function () {
        ourwheyNav_height = ourwheyNavigation.outerHeight();
        headerHeight = $('header.site_header').outerHeight();
    });
    $(window).on('scroll', function () {
        if (!isScrolling) {
            var scrollPos = $(window).scrollTop();
            var offsetHeight = $(window).width() < 769 ? ourwheyNav_height + headerHeight : ourwheyNav_height;
    
            $('.our-whey-navigation ul li a').each(function () {
                var target = $(this.hash);
                if (target.length) {
                    if (target.position().top - offsetHeight <= scrollPos && target.position().top + target.outerHeight() > scrollPos - offsetHeight) {
                        $('.our-whey-navigation ul li a').removeClass('active');
                        $(this).addClass('active');
                    }
                }
            });
        }
    });
  
    $('.our-whey-navigation ul li a').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var target = $(this.hash);
        var OurWheyNavigationHeight = $('.our-whey-navigation').outerHeight();

        if (target.length) {
            isScrolling = true;
            $('html, body').animate({
                scrollTop: target.offset().top - ourwheyNav_height - OurWheyNavigationHeight
            }, 500, function () {
                isScrolling = false;
                $('.our-whey-navigation ul li a').removeClass('active');
                $this.addClass('active');
            });
        }
    });
    
    // .nutritionists-saying-carousel [Why Our Whey Page]
    $('.custom_WhyOurWhey .nutritionists-saying-carousel').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
		centerMode: true,
        centerPadding: '140px',
        autoplay: false,
        autoplaySpeed: 2000,
		responsive: [
		{
			breakpoint: 1281,
			settings: {
                centerPadding: '80px',
			}
		},
		{
			breakpoint: 1141,
			settings: {
                centerPadding: '50px',
			}
		},
		{
			breakpoint: 992,
			settings: {
                centerPadding: '50px',
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 851,
			settings: {
                centerPadding: '50px',
				slidesToShow: 3,
                arrows: false,
			}
		},
		{
			breakpoint: 576,
			settings: {
                centerPadding: '77px',
				slidesToShow: 1,
        		arrows: false,
			}
		}
		]
	});
  
    // Onscroll Our Whey Navigation Sticky [Why Our Whey Page]
    $(window).scroll(function(){
        var sectionHeight = $('section.why-our-whey-section').outerHeight();
        var site_headerHeight = $('header.site_header').outerHeight();
    
        if ($(window).width() < 769) {
            if ($(this).scrollTop() > sectionHeight - 5) {
                $('.our-whey-navigation').addClass('sticky').parent('.shopify-section').css({"position": "sticky", "top": site_headerHeight});
            } else {
                $('.our-whey-navigation').removeClass('sticky').css('top', '');
            }
        } else {
            if ($(this).scrollTop() > sectionHeight + 100) {
                $('.our-whey-navigation').addClass('sticky').parent('.shopify-section').css({"position": "sticky", "top": "0"});
            } else {
                $('.our-whey-navigation').removeClass('sticky').css('top', '');
            }
        }
    });
  
    // Grass Glass Carousel [Why Our Whey Page]
    $('.grass-glass-carousel').slick({
        dots: false,
        arrows: true,
        infinite: false,
        // variableWidth: true,
        speed: 1000,
        slidesToShow: 4.5,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1700,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 1441,
            settings: {
                slidesToShow: 3.85,
            }
        },
        {
            breakpoint: 1367,
            settings: {
                slidesToShow: 3.65,
            }
        },
        {
            breakpoint: 1281,
            settings: {
                slidesToShow: 3.45,
            }
        },
        {
            breakpoint: 1201,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 2.8,
            }
        },
        {
            breakpoint: 851,
            settings: {
                slidesToShow: 2.1,
                arrows: false,
            }
        },
        {
            breakpoint: 641,
            settings: {
                slidesToShow: 1.9,
                arrows: false,
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1.5,
                arrows: false,
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1.25,
                arrows: false,
            }
        },
        {
            breakpoint: 390,
            settings: {
                slidesToShow: 1.10,
                arrows: false,
            }
        },
        ]
    });

    // Tastiest Carousel [Why Our Whey Page]
    $('.tastiest-carousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        // slidesToShow: 2.35,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 851,
            settings: {
                arrows: false,
            }
        },
        {
            breakpoint: 576,
            settings: {
                // slidesToShow: 1.8,
                slidesToShow: 1,
                arrows: false,
            }
        },
        {
            breakpoint: 376,
            settings: {
                // slidesToShow: 1.25,
                slidesToShow: 1,
                arrows: false,
            }
        },
        ]
    });

    // Tastiest Carousel Navigation Button [Why Our Whey Page]
    $(window).on('resize load', function () {
        var tastiestCarouselArrowsHeight = $('.tastiest-card .tastiest-img').outerHeight();
        $('.tastiest-carousel-arrow').css("height", tastiestCarouselArrowsHeight);
    });

    $('.tastiest-carousel-arrow .slick-next').click(function(){
        $(".tastiest-carousel").slick('slickNext');
    });
    
    $('.tastiest-carousel-arrow .slick-prev').click(function(){
        $(".tastiest-carousel").slick('slickPrev');
    });

    //****** About Product Modal Start [New Transparency Page] ******//
    $('.about-product-card .product-learn-more-btn .btn').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.about-product-card').next('.about-product-modal').addClass('open');
        $('body').addClass('overflow-hidden');
    });
    $('.about-product-modal .modal-close-btn, .about-product-modal .modal-overlay').on('click', function() {
        $('.about-product-modal').removeClass('open');
        $('body').removeClass('overflow-hidden');
    });
    //****** About Product Modal End [New Transparency Page] ******//

    //****** About Product Modal End [New Transparency Page] ******//
    $('.infiniteslide.logo-list').infiniteslide({
        'speed': 100,
        'direction': 'left',
        'clone': 3,
        'pauseonhover': false,
        'responsive': true,
    });
    //****** About Product Modal End [New Transparency Page] ******//

    // nutritionists-saying-carousel [Home Page] 
    $('.template-index .nutritionists-saying-carousel').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
		centerMode: true,
        centerPadding: '140px',
        autoplay: false,
        autoplaySpeed: 2000,
		responsive: [
		{
			breakpoint: 1281,
			settings: {
                centerPadding: '80px',
			}
		},
		{
			breakpoint: 1141,
			settings: {
                centerPadding: '50px',
			}
		},
		{
			breakpoint: 992,
			settings: {
                centerPadding: '50px',
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 851,
			settings: {
                centerPadding: '50px',
				slidesToShow: 3,
                arrows: false,
			}
		},
		{
			breakpoint: 576,
			settings: {
                centerPadding: '77px',
				slidesToShow: 1,
        		arrows: false,
			}
		}
		]
	});


    // blog-category-carousel [Blog Main Page]
    $('.blog-category-carousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1201,
            settings: {
                slidesToShow: 3,
            }
        },{
            breakpoint: 851,
            settings: {
                slidesToShow: 2,
            }
        },{
            breakpoint: 576,
            settings: {
                slidesToShow: 1.8,
                arrows: false,
                infinite: false,
            }
        },{
            breakpoint: 370,
            settings: {
                slidesToShow: 1.3,
                arrows: false,
                infinite: false,
            }
        }
        ]
    });

    $('.article-faqs-wrapper .article-faqs-list .article-faqs-item .article-faqs-title h3').click(function() {
        $('.article-faqs-wrapper .article-faqs-list .article-faqs-item .article-faqs-title h3').parent('.article-faqs-title').removeClass('active');
        $('.article-faqs-wrapper .article-faqs-list .article-faqs-item .article-faqs-content').slideUp();
        if (!$(this).parent('.article-faqs-title').next().is(':visible')) {
        	$(this).parent('.article-faqs-title').next().slideDown();
        	$(this).parent('.article-faqs-title').addClass('active');
        }
    });

    // New Grid Featured Slider [Home Page] 
    const debug = false;
    $('.new_grid_slider').slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 500,
		slidesToShow: 4.35,
		slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3.5,
            }
        },
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2.7,
            }
        },
        {
            breakpoint: 641,
            settings: {
                slidesToShow: 1.45,
            }
        },
        ]
	});
    if (!debug) {$('.new_grid_slider .slick-dots').hide();}
    var slider = $('.new_grid_slider');
    var scrollbarClass = "slick-scrollbar";
    slider.each(function () {
        var dots = $(this).find('.slick-dots');
        var slides = dots.find('li').length - 1;

        if (dots.length && slides >= 0) {
            var scrollId = "ssb-" + Math.random().toString(36).substring(7);
            var scrollHTML = `<div class="${scrollbarClass} ${scrollId}"><input type="range" min="0" max="${slides}" step="0.01" value="0" /></div>`;

            $(scrollHTML).insertAfter(dots);
        }
    });
    // Use event delegation for dynamically added scrollbar
    $('body').on('input change', '.' + scrollbarClass + ' input', function () {
        var current = Math.round($(this).val());
        var sliderElement = $(this).closest('.new_grid_slider');
        sliderElement.slick('slickGoTo', current);
    });
    // Sync scrollbar with slider movement
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var scrollbarInput = $(this).find("." + scrollbarClass + " input");
        if (!scrollbarInput.is(":focus")) {
            scrollbarInput.val(nextSlide);
        }
    });

    // $(window).on("scroll", function () {
    //     var scrollTop = $(this).scrollTop();
    //     var announcement_Height = $('.announcement').outerHeight();
    //     if (scrollTop === 0) {
    //         $('.announcement').slideDown();
    //         $("header.site_header").css("top", 0);
    //     } else if (scrollTop >= 32) {
    //         $('.announcement').slideUP();  
    //         $("header.site_header").css("top", announcement_Height);
    //     }
    // });


//     $(window).on("scroll", function () {
//     var scrollTop = $(this).scrollTop();
//     var $announcement = $('.announcement');
//     var announcement_Height = $('.announcement').outerHeight();
//     var $header = $("header.site_header");

//     if (scrollTop === 0) {
//         $announcement.stop(true, true).slideDown();
//         $header.css("top", announcement_Height);
//     } else if (scrollTop >= 32) {
//         $announcement.stop(true, true).slideUp();
//         $header.css("top", 0);
//     }
// });


  function announcebar_height() {
    var announcebarH = $(".announcement").outerHeight();
    $("body").css("--announcebar_height", announcebarH);
  }
  $(window).on("load resize", announcebar_height());

    let lastScrollTop = 0;
    let ticking = false;


      $(window).on("scroll", () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const scroll = $(window).scrollTop();
      
      
            if (scroll > 150) {
              $(".site_header").toggleClass("down", scroll > lastScrollTop)
                               .toggleClass("up", scroll < lastScrollTop);
            } else {
              $(".site_header").removeClass("up down");
            }
      
      
            lastScrollTop = scroll;
            ticking = false;
          });
          ticking = true;
        }
      });

        $(window).on('load resize orientationchange', function () {
		$('.slider_active').each(function () {
			var $video_gallery_wpr = $(this);
			if ($(window).width() > 769) {
				if ($video_gallery_wpr.hasClass('slick-initialized')) {
					$video_gallery_wpr.slick('unslick');
				}
			} else {
				if (!$video_gallery_wpr.hasClass('slick-initialized')) {
					$video_gallery_wpr.slick({
						slidesToShow: 2.2,
						slidesToScroll: 1,
						dots: false,
						arrows: false,
						infinite: false,
						autoplay: false,
                        responsive: [
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 1.15,
                            slidesToScroll: 1,
                          },
                        },
                      ],
					});
				}
			}
		});
	});


  
});



// hulk page refresh
window.addEventListener("message", function(event) {
  if (event.data === "refresh-parent") {
    location.reload();
  }
});

// testimonials_slider

$('.multiple-items').slick({
  infinite: false,
  slidesToShow: 3,
  dots: true,
  arrows: false,
  button:false,
  slidesToScroll: 2,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true
      }
    },
      {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// 24-12-2025
  document.addEventListener("DOMContentLoaded", function () {
    const announcementBar = document.querySelector(".announcement-bar-wrapper");

    if (announcementBar) {
      announcementBar.addEventListener("click", function () {
        this.classList.toggle("active");
      });
    }
  });



//   var inner_flavour_slider = new Swiper(".inner_flavour_slider", {
//         slidesPerView: 'auto',
//         spaceBetween: 15,
//         slidesOffsetAfter:15,
//          freeMode: true,
//           scrollbar: {
//             el: '.js-swiper-scrollbar',
//             draggable: true,
//             snapOnRelease: true
//           },
//           breakpoints: {
//             641: {
//                 slidesPerView: 'auto',
//                 spaceBetween: 11
//             }
//         }
//       });


// 05-01-2026 

document.addEventListener("DOMContentLoaded", function () {
  const allSelects = document.querySelectorAll(".subscribe_options");
  const moneyFormat = window.themeMoneyFormat || "${{amount}}";

  function formatMoney(cents) {
    let value = (cents / 100).toFixed(2);

    if (moneyFormat.includes("{{amount_no_decimals}}")) {
      value = Math.round(cents / 100).toString();
      return moneyFormat.replace("{{amount_no_decimals}}", value);
    }

    if (moneyFormat.includes("{{amount}}")) {
      return moneyFormat.replace("{{amount}}", value);
    }

    return value;
  }

  function updatePrice(selectBox) {
    const productCard = selectBox.closest(".grid-product");
    if (!productCard) return;

    const priceBox = productCard.querySelector(".subscribe_grid_pp .subs_price");
    if (!priceBox) return;

    const selectedOption = selectBox.options[selectBox.selectedIndex];
    let price = parseInt(selectedOption.dataset.price);

    let discountedPrice = Math.round(price - (price * 0.05));

    priceBox.innerHTML = formatMoney(discountedPrice);
  }

  allSelects.forEach(function (selectBox) {
    selectBox.addEventListener("change", function () {
      updatePrice(this);
    });

    updatePrice(selectBox);
  });
});